export default {
  title: 'Winkeldomein',
  description:
    'Laat de onlinewinkels van uw restaurants draaien op een eigen domein in plaats van op het gedeelde adres, bijvoorbeeld pizza-mario.bestellen-uwmerk.nl. U voegt één keer twee DNS-records toe; elk restaurant dat u later toevoegt, krijgt automatisch zijn adres.',
  read_only_description:
    'Het domein waarop de winkels van de restaurants van deze partner draaien. Alleen de partner kan het koppelen of wijzigen.',
  read_only_empty: 'Deze partner heeft geen winkeldomein gekoppeld.',
  not_connected: {
    label: 'Domein voor de winkels van uw restaurants',
    hint: 'Een domein of subdomein dat van u is, bijvoorbeeld bestellen-uwmerk.nl. Het moet een ander domein zijn dan dat waarop de apps van uw team draaien — geen subdomein daarvan.',
    placeholder: 'bestellen-uwmerk.nl',
    connect: 'Koppelen',
  },
  status: {
    pending_dns: 'Wacht op DNS',
    active: 'Live',
    failed: 'Actie vereist',
    disabled: 'Ontkoppeld',
  },
  primary_badge: 'Primair',
  summary: {
    pending: 'We wachten op uw DNS-records. Dit duurt meestal een paar minuten en soms een paar uur.',
    failed:
      'We konden niet alle records op tijd bevestigen. Herstel het record dat hieronder is gemarkeerd en klik dan op Opnieuw controleren — vanaf dan controleren we opnieuw.',
    failed_leave: 'Om in plaats daarvan een ander domein te koppelen, ontkoppel dit domein eerst.',
    live: '{{host}} is live.',
    primary: 'Elk nieuw restaurant krijgt hierop automatisch zijn adres.',
    standby:
      'Maak het primair, zodat elk nieuw restaurant het automatisch krijgt. Restaurants die al op een ander domein staan, blijven waar ze zijn.',
    regressed:
      '{{host}} is live, maar een record hieronder wordt niet meer bevestigd. Uw winkels zijn nog online — herstel het record bij uw DNS-provider.',
  },
  instructions: {
    title: 'Zo voegt u de records toe',
    step_provider:
      'Log in waar de DNS van {{root}} wordt beheerd — meestal bij de partij waar u het domein hebt gekocht.',
    step_add: 'Voeg elk record hieronder precies zo toe als getoond: het type, de naam en de waarde.',
    step_check: 'Sla op en klik dan op „{{button}}”. We blijven zelf ook controleren.',
    tip_name:
      'De meeste providers willen in het naamveld alleen het deel vóór {{root}} — _foodamigos-verify en *. De volledige naam staat eronder, voor providers die daarom vragen.',
    tip_wildcard:
      'Het record * stuurt elk adres onder {{root}} naar uw winkels, zodat u nooit een record per restaurant hoeft toe te voegen.',
    tip_existing:
      'Bestaande records voor {{root}}, zoals die voor uw website, e-mail of www, blijven werken: het record * geldt alleen voor namen zonder eigen record. Heeft {{root}} al een record *, vervang het dan door dat van ons.',
    tip_cloudflare:
      'Zet bij Cloudflare het CNAME-record op „Alleen DNS” (grijze wolk), anders kunnen we het niet zien.',
  },
  records: {
    title: 'Voeg deze DNS-records voor {{root}} toe bij uw domeinprovider',
  },
  example: 'Een restaurant staat dan op een adres zoals {{host}}.',
  example_label: 'uw-restaurant',
  buttons: {
    check_again: 'Opnieuw controleren',
    make_primary: 'Primair maken',
    unlink: 'Ontkoppelen',
    retry: 'Opnieuw proberen',
  },
  primary_unavailable: 'Beschikbaar zodra het domein live is.',
  unlink_blocked_one:
    '{{count}} restaurant staat nog op dit domein. Verplaats het naar een ander domein voordat u ontkoppelt.',
  unlink_blocked_other:
    '{{count}} restaurants staan nog op dit domein. Verplaats ze naar een ander domein voordat u ontkoppelt.',
  unlink_confirm: {
    title: '{{host}} ontkoppelen?',
    description: 'U kunt {{host}} later opnieuw koppelen.',
    description_primary:
      'Nieuwe restaurants krijgen weer een adres op het gedeelde domein. U kunt {{host}} later opnieuw koppelen.',
    ok: 'Ontkoppelen',
  },
  toasts: {
    load_error: 'Uw winkeldomein kon niet worden geladen',
    load_error_read_only: 'Het winkeldomein van deze partner kon niet worden geladen',
    connected: 'Domein gekoppeld — voeg nu de records hieronder toe',
    connect_failed: 'Het domein kon niet worden gekoppeld',
    check_started: 'Opnieuw controleren…',
    check_failed: 'De controle kon niet worden gestart. Probeer het over een minuut opnieuw.',
    primary_set: 'Nieuwe restaurants krijgen nu dit domein',
    primary_failed: 'Dit domein kon niet primair worden gemaakt',
    unlinked: 'Domein ontkoppeld',
    unlink_failed: 'Het domein kon niet worden ontkoppeld',
    unlink_has_restaurants_one:
      '{{count}} restaurant staat nog op {{host}}: {{names}}. Verplaats het naar een ander domein voordat u ontkoppelt.',
    unlink_has_restaurants_other:
      '{{count}} restaurants staan nog op {{host}}: {{names}}. Verplaats ze naar een ander domein voordat u ontkoppelt.',
    gone: '{{host}} is niet meer gekoppeld — misschien is het in een ander tabblad ontkoppeld.',
  },
};
